import { Button, Image } from "antd";
import { GiftOutlined } from "@ant-design/icons";
import { Locale } from "../../../utils";

const i18n = Locale.getInstance();
const TYPE_BOX = 2;

export const qrcodeDetailListColumns = (
  userToken,
  setLoading,
  history,
  onTransferToVip
) => {
  return [
    {
      title: "ID",
      dataIndex: "id",
    },
    {
      title: i18n.t("qrcode.itemCode"),
      dataIndex: "code",
      render: (code, record) => code ?? record?.item?.code ?? "—",
    },
    {
      title: i18n.t("qrcode.type"),
      dataIndex: "type_label",
    },
    {
      title: i18n.t("qrcode.userMobile"),
      render: (_, record) => record?.user?.mobile ?? record?.mobile ?? "—",
    },
    {
      title: i18n.t('financeAccount.listHeaderStatus'),
      dataIndex: "status_label",
    },
    {
      title: i18n.t("users.avatar"),
      render: (item) => {
        if (!item.avatar) return null;
        return (
          <>
            <img
              src={item.avatar}
              alt={item.nickname}
              width={60}
              height={60}
            />
          </>
        );
      },
    },
    {
      title: i18n.t("qrcode.prize"),
      dataIndex: "prize",
      render: (prize, record) => (
        <div>
          <div>
            <Image width={100} src={i18n.getPropNameByLocale(prize, 'image')} />
          </div>
          <div>
            <a>{i18n.getPropNameByLocale(prize)}</a>
          </div>
        </div>
      ),
    },
    {
      title: i18n.t("qrcode.redPacketAmount"),
      dataIndex: "red_packet_amount"
    },
    {
      title: i18n.t("qrcode.regionName"),
      render: (item) => {
        return <span>{i18n.getPropNameByLocale(item.region, "name")}</span>;
      }
    },
    {
      title: i18n.t("qrcode.scannedAt"),
      render: (item) => {
        return <span>{item.scanned_at}</span>;
      }
    },
    {
      title: i18n.t("qrcode.drawndAt"),
      render: (item) => {
        return <span>{item.drawn_at}</span>;
      }
    },
    {
      title: i18n.t("qrcode.exchangedAt"),
      render: (item) => {
        return <span>{item.exchanged_at}</span>;
      },
    },
    ...(onTransferToVip
      ? [
          {
            title: i18n.t("users.actions"),
            key: "actions",
            width: 120,
            fixed: "right",
            render: (_, record) =>
              record.type === TYPE_BOX ? (
                <Button
                  type="link"
                  size="small"
                  icon={<GiftOutlined />}
                  onClick={() => onTransferToVip(record)}
                >
                  {i18n.t("qrcode.transferToVip")}
                </Button>
              ) : null,
          },
        ]
      : []),
  ];
};
